/* © CNES */
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { useNavigate } from 'react-router-dom';
import Logos from '../../assets/images/logosToolbarLightGeodes.png';
import './PageRateLimiting.scss';

/**
 * PageRateLimiting Page displayed when application has received a 429 error.
 * @returns Element.
 */
export const PageRateLimiting = () => {
  const navigate = useNavigate();

  return (
    <div className="MaintenanceContainer">
      <div className="HeaderContainer">
        <Image aria-label="Logos" src={Logos} alt="app_logos" width="360" />
      </div>

      <div className="IllustrationContainer">
        <img
          alt="Maintenance page illustration"
          src={require('../../assets/images/pageMaintenance.png')}
        />
      </div>

      <div className="TextContainer">
        <h1 className="TextTitle">EARTH NOT FOUND</h1>
        <h3 className="TextDescription">
          Geodes Portal is currently experiencing high demand. Please wait a
          moment before trying again. We are doing our best to respond to all
          requests. Thank you for your understanding and patience.
        </h3>
      </div>

      <div className="ButtonContainer">
        <Button
          label="Return to GEODES"
          className="MaintenanceButton"
          onClick={() => {
            navigate('/');
          }}
        ></Button>
      </div>
    </div>
  );
};
